module.exports = "data:image/svg+xml;base64,PHN2ZyB2aWV3Ym94PSIwIDAgMTggMTgiPgogIDxwYXRoIGNsYXNzPSJxbC1maWxsIiBkPSJNMTQsMTZINGExLDEsMCwwLDEsMC0ySDE0QTEsMSwwLDAsMSwxNCwxNloiLz4KICA8cGF0aCBjbGFzcz0icWwtZmlsbCIgZD0iTTE0LDRINEExLDEsMCwwLDEsNCwySDE0QTEsMSwwLDAsMSwxNCw0WiIvPgogIDxyZWN0IGNsYXNzPSJxbC1maWxsIiB4PSIzIiB5PSI2IiB3aWR0aD0iMTIiIGhlaWdodD0iNiIgcng9IjEiIHJ5PSIxIi8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/quill/assets/icons/float-center.svg
// module id = hlEI
// module chunks = 4